var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 667,
    viewBox: "0 0 546 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_247_613096)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 423.001,
    cy: 327.151,
    r: 338.846,
    transform: "rotate(-90 423.001 327.151)",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.001,
    cy: 327.151,
    r: 338.846,
    transform: "rotate(-90 423.001 327.151)",
    fill: "url(#paint0_linear_247_613096)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.001,
    cy: 327.151,
    r: 338.846,
    transform: "rotate(-90 423.001 327.151)",
    fill: "url(#paint1_radial_247_613096)",
    fillOpacity: 0.95
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 423.001,
    cy: 327.151,
    r: 339.096,
    transform: "rotate(-90 423.001 327.151)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_247_613096)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 422.997,
    cy: 160.846,
    r: 338.846,
    transform: "rotate(90 422.997 160.846)",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.997,
    cy: 160.846,
    r: 338.846,
    transform: "rotate(90 422.997 160.846)",
    fill: "url(#paint2_linear_247_613096)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.997,
    cy: 160.846,
    r: 338.846,
    transform: "rotate(90 422.997 160.846)",
    fill: "url(#paint3_radial_247_613096)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 422.997,
    cy: 160.846,
    r: 339.096,
    transform: "rotate(90 422.997 160.846)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_247_613096)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 339.846,
    cy: 243.998,
    r: 338.846,
    transform: "rotate(90 339.846 243.998)",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.846,
    cy: 243.998,
    r: 338.846,
    transform: "rotate(90 339.846 243.998)",
    fill: "url(#paint4_linear_247_613096)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.846,
    cy: 243.998,
    r: 338.846,
    transform: "rotate(90 339.846 243.998)",
    fill: "url(#paint5_radial_247_613096)",
    fillOpacity: 0.95
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 339.846,
    cy: 243.998,
    r: 339.096,
    transform: "rotate(90 339.846 243.998)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_247_613096)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 506.154,
    cy: 243.998,
    r: 338.846,
    transform: "rotate(-90 506.154 243.998)",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.154,
    cy: 243.998,
    r: 338.846,
    transform: "rotate(-90 506.154 243.998)",
    fill: "url(#paint6_radial_247_613096)",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.154,
    cy: 243.998,
    r: 338.846,
    transform: "rotate(-90 506.154 243.998)",
    fill: "url(#paint7_linear_247_613096)",
    fillOpacity: 0.65
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 506.154,
    cy: 243.998,
    r: 339.096,
    transform: "rotate(-90 506.154 243.998)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_247_613096",
    x: 83.6554,
    y: -12.1953,
    width: 678.692,
    height: 678.692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_247_613096"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_247_613096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_247_613096",
    x: 83.6506,
    y: -178.5,
    width: 678.692,
    height: 678.692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_247_613096"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_247_613096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_247_613096",
    x: 0.500244,
    y: -95.3477,
    width: 678.692,
    height: 678.692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_247_613096"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_247_613096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_247_613096",
    x: 166.808,
    y: -95.3477,
    width: 678.692,
    height: 678.692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_247_613096"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_247_613096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_247_613096",
    x1: 1050.07,
    y1: 59.4751,
    x2: 403.608,
    y2: 181.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_247_613096",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(667.231 328.48) rotate(-180) scale(664.284)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842199,
    stopColor: "#FF5334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_247_613096",
    x1: -409.736,
    y1: 273.997,
    x2: 337.022,
    y2: 564.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.518602,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_247_613096",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(422.997 160.846) rotate(179.827) scale(440.022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_247_613096",
    x1: 966.918,
    y1: -23.6774,
    x2: 320.453,
    y2: 97.9366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_247_613096",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.451 277.992) rotate(21.7389) scale(679.315 771.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224735,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37505,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66121,
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783675,
    stopColor: "#FF5334"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_247_613096",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(637.944 160.844) rotate(137.992) scale(541.057)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#FFAC23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_247_613096",
    x1: 1133.23,
    y1: -23.6774,
    x2: 486.76,
    y2: 97.9366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeimg);
export default __webpack_public_path__ + "static/media/homeimg.28c9ab84bcbe6c415a5c90399bb384ed.svg";
export { ForwardRef as ReactComponent };